import { Badge } from "@admin/components/atoms/Badge";
import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import {
  ControlPeriod,
  FoodControlPoint,
  getCategoryName,
} from "@enos-monorepo/lib";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { EditControlPeriodModal } from "./Modals/EditControlPeriodModal";
import { EditControlStatusModal } from "./Modals/EditControlStatusModal";

export function PeriodicControlPointsTable({
  foodControlPoints,
  controlPeriods,
  isPending = false,
}: {
  foodControlPoints: FoodControlPoint[];
  controlPeriods: ControlPeriod[];
  isPending: boolean;
}) {
  const { t } = useTranslation();
  const [selectedControlPoint, setSelectedControlPoint] =
    useState<FoodControlPoint>();
  const [isEditControlStatusModalOpen, setIsEditControlStatusModalOpen] =
    useState(false);
  const [isEditControlPeriodModalOpen, setIsEditControlPeriodModalOpen] =
    useState(false);
  const dataColumns: DataTableColumn<FoodControlPoint>[] = [
    {
      header: t("common.Name"),
      accessorKey: "name",
      enableSorting: true,
      sortingFn: "alphanumeric",
      cell: ({ row }) => row.original.name,
    },
    {
      header: "Category",
      accessorKey: "category",
      cell: ({ row }) => getCategoryName(row.original),
    },
    {
      header: t("common.Status"),
      accessorKey: "status",
      cell: ({ row }) => (
        <Badge
          size="lg"
          className={"hover:cursor-pointer"}
          type={row.original.isDeleted ? "danger" : "success"}
          onClick={() => setIsEditControlStatusModalOpen(true)}
        >
          {row.original.isDeleted ? "Inactive" : "Active"}
        </Badge>
      ),
    },
    {
      header: "Period",
      cell: ({ row }) => (
        <Badge
          type="dark"
          size="lg"
          className={"hover:cursor-pointer"}
          onClick={() => setIsEditControlPeriodModalOpen(true)}
        >
          {
            controlPeriods?.find(
              (period) => period.id === row.original.controlPeriodId,
            )?.description
          }
        </Badge>
      ),
    },
  ];

  return (
    <>
      <DataTable
        loading={isPending}
        columns={dataColumns}
        sorting={[{ id: "name", desc: false }]}
        data={foodControlPoints}
        onRowClick={(row) => setSelectedControlPoint(row)}
        title="Periodic Control Points"
        isInfoIcon={false}
      />
      <EditControlStatusModal
        open={isEditControlStatusModalOpen}
        onClose={() => setIsEditControlStatusModalOpen(false)}
        controlPoint={selectedControlPoint}
      />
      <EditControlPeriodModal
        controlPoint={selectedControlPoint}
        open={isEditControlPeriodModalOpen}
        controlPeriods={controlPeriods}
        onClose={() => setIsEditControlPeriodModalOpen(false)}
      />
    </>
  );
}
